import './sswps.js';

export const BaseGateway = window.sswps.BaseGateway;
export const AfterPay = window.sswps.AfterPay;
export const ApplePay = window.sswps.ApplePay;
export const CartGateway = window.sswps.CartGateway;
export const CheckoutFields = window.sswps.CheckoutFields;
export const CheckoutGateway = window.sswps.CheckoutGateway;
export const GooglePay = window.sswps.GooglePay;
export const PaymentRequest = window.sswps.PaymentRequest;
export const ProductGateway = window.sswps.ProductGateway;
export const stripe = window.sswps.stripe;
export const sswps = window.sswps;